import React from 'react';
import '../styles/loading.css'; // Import your loading animation styles

function Loading() {
  return (
    <div className ="center">
        <div className ="wave"></div>
        <div className ="wave"></div>
        <div className ="wave"></div>
        <div className ="wave"></div>
        <div className ="wave"></div>
        <div className ="wave"></div>
        <div className ="wave"></div>
        <div className ="wave"></div>
        <div className ="wave"></div>
        <div className ="wave"></div>
    </div>
  );
}

export default Loading;
